import type { CSSProperties, ReactNode } from 'react'

interface ScrollableListProps {
  children: ReactNode
  maxVisibleItems?: number
  itemHeight?: number
  className?: string
  style?: CSSProperties
}

export function ScrollableList({
  children,
  maxVisibleItems = 5,
  itemHeight = 40,
  className = '',
  style,
}: ScrollableListProps) {
  return (
    <div
      className={`overflow-y-auto ${className}`.trim()}
      style={{
        maxHeight: maxVisibleItems * itemHeight,
        ...style,
      }}
    >
      {children}
    </div>
  )
}
